var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-[160px] w-full overflow-hidden"},[(_vm.loading)?_c('div',{staticClass:"flex h-full items-center justify-center"},[_c('div',{staticClass:"h-full w-full animate-pulse rounded-xl bg-slate-100"})]):_c('apex-chart',{attrs:{"type":"line","options":_vm.options,"series":_vm.data,"height":"165"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }